// **** Constants **** //

export const MAX_TASK_NAME_CHAR_LENGTH = 255;
export const MAX_TASK_DESCRIPTION_CHAR_LENGTH = 100;
const ADMIN_PATHS_ROOT = '/adminConfiguration';
const NON_PHYSICAL_TASK_PATH_ROOT = `${ADMIN_PATHS_ROOT}/nonPhysicalTaskConfiguration`;
const TASK_PATH_ROOT = `${ADMIN_PATHS_ROOT}/taskConfiguration`;
const FORM_PATH_ROOT = `${ADMIN_PATHS_ROOT}/restrictionFormConfiguration`;

export const AdminConfigPaths = {
  root: ADMIN_PATHS_ROOT,
  SITE: `${ADMIN_PATHS_ROOT}/siteConfiguration`,
  Task: {
    root: TASK_PATH_ROOT,
    TASKS: `${TASK_PATH_ROOT}/task`,
    TASK_GROUPS: `${TASK_PATH_ROOT}/taskGroup`,
  },
  NonPhysicalTask: NON_PHYSICAL_TASK_PATH_ROOT,
  Form: {
    root: FORM_PATH_ROOT,
    TABLE: `${FORM_PATH_ROOT}/forms`,
    EDIT: `${FORM_PATH_ROOT}/edit`,
  },
  MODIFICATION: `${ADMIN_PATHS_ROOT}/jobModificationConfiguration`,
} as const;
